import { render, staticRenderFns } from "./BpCarousel.vue?vue&type=template&id=f379c9cc&"
import script from "./BpCarousel.vue?vue&type=script&lang=js&"
export * from "./BpCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f379c9cc')) {
      api.createRecord('f379c9cc', component.options)
    } else {
      api.reload('f379c9cc', component.options)
    }
    module.hot.accept("./BpCarousel.vue?vue&type=template&id=f379c9cc&", function () {
      api.rerender('f379c9cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/styles/organisms/carousel/BpCarousel.vue"
export default component.exports